var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"id":"w2gwi0j8ha","d":"M0 0L15 0 15 15 0 15z"})),React.createElement("g",{"fill":"none","fillRule":"evenodd","key":1},[React.createElement("mask",{"id":"dh5qr9r1ub","fill":"#fff","key":0},React.createElement("use",{"xlinkHref":"#w2gwi0j8ha"})),React.createElement("path",{"fill":"#FFF","d":"M14.253 6.753H8.247V.747C8.247.334 7.912 0 7.5 0s-.747.334-.747.747v6.006H.747C.334 6.753 0 7.088 0 7.5s.334.747.747.747h6.006v6.006c0 .413.335.747.747.747s.747-.334.747-.747V8.247h6.006c.413 0 .747-.335.747-.747s-.334-.747-.747-.747","mask":"url(#dh5qr9r1ub)","key":1})])]);
}

Plus.defaultProps = {"width":"15","height":"15","viewBox":"0 0 15 15"};

module.exports = Plus;

Plus.default = Plus;
